import { Component, inject, OnInit } from '@angular/core';
import { LowerCasePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CATEGORIES } from '../../../assets/data/categories';
import { DataService } from '../../services/data.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-infinite-carousel',
  imports: [RouterLink, TranslateModule, LowerCasePipe],
  templateUrl: './infinite-carousel.component.html',
  styleUrl: './infinite-carousel.component.css'
})
export class InfiniteCarouselComponent implements OnInit {

  private dataService = inject(DataService);

  categories = CATEGORIES;
  randomImages: Map<string, number> = new Map();

  ngOnInit(): void {
    this.loadRandomImages();
  }

  loadRandomImages(): void {
    this.dataService.getRandomCategories().subscribe(randomCategories => {
      randomCategories.forEach(rc => {
        this.randomImages.set(rc.categoria.toLowerCase(), rc.OBJECTID);
      });
    });
  }

  getCardImage(code: string): string {
    const objectId = this.randomImages.get(code.toLowerCase());
    if (objectId) {
      return `/assets/images/wonders/${objectId}-1.jpg`;
    }
    return '/assets/images/wonders/accommodation1.jpg';
  }
}
